<div class="p-fluid">
  <div *ngIf="props.label" class="b-f-customformfield-label">
    <label *ngIf="props.label" [attr.for]="id" class="basin-mb-0"
      >{{ props.label
      }}<span *ngIf="props.required">{{ props.required ? '*' : '' }} </span>
    </label>
    <div
      *ngIf="props.tooltip"
      class="symbol-info b-f-customformfield-tooltip tooltip-icon"
      [pTooltip]="props.tooltip"
    ></div>
  </div>
  <ng-container #fieldComponent></ng-container>

  <div
    *ngIf="props && props.description"
    class="b-f-customformfield-descriptioncontainer"
  >
    <small
      [ngClass]="{
        'basin-action-link p-button-text b-f-customformfield-actiondescription':
          props.actionDescription,
        'b-f-customformfield-description': true
      }"
      (mousedown)="props.actionDescription && actionDescriptionClicked($event)"
      >{{ props.description }}</small
    >
  </div>

  <div *ngIf="showError" class="error-container">
    <small class="p-error" role="alert" *ngFor="let error of errors">
      {{ error.message }}
    </small>
  </div>
</div>
